define((require) => {
    "use strict";

    const Marionette              = require("marionette");
    const _                       = require("underscore");
    const ButtonIconCollection    = require("ui/experience/widgets/button/ButtonIconCollection");
    const template                = require("ui/experience/widgets/button/ButtonIconCollectionView.tpl");

    const RENDER_CHUNK_SIZE = 1;

    const IconItemView = Marionette.ItemView.extend({
        tagName: "div",

        className: "icon",

        events: {
            "click": function() {
                this.viewScope.onButtonIconClick(this.model);
            }
        },

        initialize() {
            this.$el.attr("title", this.model.get("name"));
        },

        template: _.template("<i class='material-icons'><%- iconId %></i>"),

        showHideView(shouldBeShown) {
            this.$el.toggleClass("hidden", !shouldBeShown);
        }
    });

    return Marionette.CompositeView.extend("ButtonIconCollectionView", {

        className: "button-icon-collection-view",

        template,

        itemView: IconItemView,

        itemViewContainer: ".icons-container",

        _renderLoopId: null,

        _renderIndex: 0,

        initialize() {
            this._renderNext = this._renderNext.bind(this);
            this._renderChunks = this._renderChunks.bind(this);
            this.collection = new ButtonIconCollection();
        },

        onShow() {
            _.delay(this._renderNext, 500);
        },

        onClose() {
            cancelAnimationFrame(this._renderLoopId);
        },

        _renderNext() {
            this._renderLoopId = requestAnimationFrame(this._renderChunks);
        },

        _renderChunks() {
            const collection = this.options.model.get("collection");
            let icon;
            const t = this._renderIndex + RENDER_CHUNK_SIZE;

            for (; this._renderIndex < t; this._renderIndex++) {
                icon = collection.models[this._renderIndex];

                if (!icon) {
                    break;
                }

                this.collection.add(icon);
            }

            if (icon) {
                this._renderNext();
            } else {
                cancelAnimationFrame(this._renderLoopId);
            }
        },

        /**
         * Hide icons that are filtered out by the search term and name and return if all icons are hidden.
         * @param {String} upperCaseSearchTerm
         * @returns {Boolean} true if all icons are hidden
         */
        filterShownItemsAndReturnIsHidden(upperCaseSearchTerm) {
            let amountOfHiddenItemViews = 0;
            this.children.forEach((child) => {
                const shouldBeShown = (upperCaseSearchTerm === "" || child.model.get("name").toUpperCase().indexOf(upperCaseSearchTerm) > -1);
                child.showHideView(shouldBeShown);
                if (!shouldBeShown) {
                    amountOfHiddenItemViews++;
                }
            });
            const shouldCollectionViewBeHidden = (amountOfHiddenItemViews === this.children.length);
            this.$el.toggleClass("hidden", shouldCollectionViewBeHidden);

            return shouldCollectionViewBeHidden;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/button/ButtonIconCollectionView.js